export const filterUsers = (users, role) => {
    return users//preceding lines just a backup in case we'll need to filter assignees by role
    if(!users || !role) return users
    return users.filter(x => x.roles.toLowerCase() === role.toLowerCase())
}